import { Box, Pagination, Typography, useMediaQuery, useTheme } from "@mui/material";

interface ITablePaginationProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
}

const TablePagination = ({ count, page, rowsPerPage, onPageChange }: ITablePaginationProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const totalPages = Math.ceil(count / rowsPerPage);

  if (totalPages <= 1) return null;

  const start = page * rowsPerPage + 1;
  const end = Math.min((page + 1) * rowsPerPage, count);

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      justifyContent="space-between"
      alignItems={isMobile ? "flex-start" : "center"}
      mt={3}
      gap={isMobile ? 1 : 0}
    >
      <Typography variant="body2" sx={{ ml: isMobile ? 0 : 1, fontSize: isMobile ? 12 : 14 }}>
        Mostrando {start}-{end} de {count} registros
      </Typography>
      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={(_, value) => onPageChange(value - 1)}
        color="primary"
        showFirstButton={!isMobile}
        showLastButton={!isMobile}
        size={isMobile ? "small" : "medium"}
        sx={{
          "& .MuiPaginationItem-root": {
            borderRadius: "50%",
          },
        }}
      />
    </Box>
  );
};

export default TablePagination;
